export default {
    props: {
        order: {
            type: Object,
            required: true
        }
    }
}